/* src/pages/user-management/page-user-management.component.scss */
:host {
  display: block;
}
.user-management__filters__search-users,
.user-management__filters__search-company {
  width: 100%;
}
.user-management__users {
  width: 100%;
}
.user-management__users__user {
  --chevron-rotation: 0deg;
  --company-summary-max-width: 100%;
  --summary-duration: 250ms;
}
.user-management__users__user[open] {
  --chevron-rotation: 180deg;
  --company-summary-max-width: 0;
}
.user-management__users__user summary {
  list-style: none;
}
.user-management__users__user__company-summary {
  max-width: var(--company-summary-max-width);
  position: relative;
  transition: max-width var(--summary-duration) ease-in-out;
  overflow: hidden;
  white-space: nowrap;
  float: right;
}
.user-management__users__user__chevron {
  height: 1rem;
  width: 1rem;
  position: relative;
  float: right;
  transform: rotate(var(--chevron-rotation));
  transition: transform var(--summary-duration) ease-in-out;
  margin-left: var(--vwui--spacing--md);
}
.user-management__users__user__edit-button {
  float: right;
}
.user-management__users__user__companies {
  border-top: var(--vwui--color--border-light) solid thin;
  width: 100%;
  table-layout: fixed;
  overflow: hidden;
}
.user-management__users__user__companies__header {
  padding-top: var(--vwui--spacing--xs);
  padding-bottom: var(--vwui--spacing--xs);
  font-size: var(--vwui-size-font-sm);
  font-weight: var(--vwui-font-weight-semibold);
  color: var(--vwui--color--neutral-1);
  text-align: left;
}
.user-management__users__user__companies__header__right-column {
  text-align: center;
  width: 8rem;
}
.user-management__users__user__companies__right-column {
  text-align: center;
}
/*# sourceMappingURL=page-user-management.component-HZV225LB.css.map */
